// extracted by mini-css-extract-plugin
module.exports = {"cardTitle":"EmailInput_cardTitle__1OVbt","addBtn":"EmailInput_addBtn__2FqP8","closeBtn":"EmailInput_closeBtn__1HFOR"};